import React, { useState, useEffect } from 'react';
import { Button, Table, Spinner } from 'react-bootstrap';
import TablePaginationBar from '../components/TablePaginationBar';
import { BsThreeDots } from 'react-icons/bs';
import { useData } from '../context/DataContext';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import { getbusinesses, updateBusinessStatus } from '../config/url';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';

const Businesses = () => {
  const [businesses, setBusinesses] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [businessesPerPage, setBusinessesPerPage] = useState(10);

  const businessData = useFetchData(getbusinesses, config);
  const filteredBusinesses = businesses.filter((business) => {
    if (statusFilter === '' || statusFilter === 'Status') {
      return true; // Show all businesses when Status is selected
    }
    if (statusFilter === 'active') {
      return business.status; // Show only active businesses
    }
    if (statusFilter === 'inactive') {
      return !business.status; // Show only inactive businesses
    }
    return true;
  });

  // Pagination
  const indexOfLastBusiness = currentPage * businessesPerPage;
  const indexOfFirstBusiness = indexOfLastBusiness - businessesPerPage;
  const currentBusinesses = filteredBusinesses.slice(
    indexOfFirstBusiness,
    indexOfLastBusiness
  );
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const changeStatus = async (id) => {
    try {
      const res = await axios.put(`${updateBusinessStatus}/${id}`, config);
      if (res.data.success) {
        setBusinesses((prevState) => {
          return prevState.map((data) =>
            data._id === res.data.data._id ? res.data.data : data
          );
        });
      } else {
        console.log('Could not update request');
      }
    } catch (error) {
      console.log(error);
    }
  };

  const count = (array) => {
    return Array.isArray(array) ? array.length : 0; // Check if it's an array and return its length
  };

  const navigate = useNavigate();

  // Update businesses when data is loaded
  useEffect(() => {
    // Only update businesses when loading is complete
    if (businessData?.loading === false) {
      if (Array.isArray(businessData?.data) && businessData.data.length > 0) {
        setBusinesses(businessData.data);
      } else {
        // Explicitly set empty array when response comes back with no businesses or null/undefined
        setBusinesses([]);
      }
    }
  }, [businessData]);

  // Reset to first page when filter changes to avoid empty pages
  useEffect(() => {
    setCurrentPage(1);
  }, [statusFilter]);

  return (
    <div className='app-page'>
      <div className='bg-white rounded shadow-sm'>
        <div className="app-page-toolbar">
          <h2 className="app-page-title">Businesses</h2>
          <div className="app-page-toolbar-filters">
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="form-select app-filter-select"
              style={{ width: "140px" }}
            >
              <option value="">Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
            <Button
              className="app-filter-action-btn"
              onClick={() => navigate("/businesses/addbusiness")}
            >
              Add New
            </Button>
          </div>
        </div>
        {businessData?.loading === true ? (
          <div className="text-center py-5">
            <Spinner animation="border" variant="primary" />
            <div className="mt-3 text-muted">Loading businesses...</div>
          </div>
        ) : filteredBusinesses.length === 0 ? (
          <div className="text-center p-4">No businesses found.</div>
        ) : (
          <>
            <Table
              responsive
              hover
              className='mb-0'
              style={{
                borderCollapse: 'separate',
                borderSpacing: '0 10px',
              }}
            >
              <thead
                style={{
                  backgroundColor: '#064260',
                  color: 'white',
                  textAlign: 'center',
                  height: '50px',
                  verticalAlign: 'middle',
                }}
              >
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Total Codes</th>
                  <th>Active Codes</th>
                  <th>Status</th>
                  <th style={{width: "150px"}}>Action</th>
                </tr>
              </thead>
              <tbody style={{ textAlign: 'center', color: '#575757', fontFamily: 'Poppins', fontWeight: 500, fontSize: '14px' }}>
                {currentBusinesses.map((business, index) => (
                  <tr key={business.id} style={{ backgroundColor: 'white' }}>
                    <td>{(index + 1+((currentPage-1)*businessesPerPage)).toString().padStart(4,"0")}</td>
                    <td>{business.businessName}</td>
                    <td>{count(business.access_codes)}</td>
                    <td>{business.access_codes.filter(code => code.status === 'Active').length}</td>
                    <td>{business.status ? "Active" : "Inactive"}</td>
                    <td>
                    <Button
                      className="app-view-btn"
                      onClick={() => navigate(`/businesses/${business.id}`, { state: { business } })}
                    >
                      View
                    </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <TablePaginationBar
              currentPage={currentPage}
              totalItems={filteredBusinesses.length}
              rowsPerPage={businessesPerPage}
              onPageChange={paginate}
              onRowsPerPageChange={(n) => {
                setBusinessesPerPage(n);
                setCurrentPage(1);
              }}
              rowsPerPageOptions={[10, 25, 50]}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Businesses;
